import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-product-samples-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './product-samples-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: ProductSamplesTabComponent },
  ],
})
export class ProductSamplesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('ProductSamples');

  userId = input<string>();
  endpoint = computed(() => {
    const base = '/visits/tables/product-samples';
    const id = this.userId();
    return id ? `${base}/${id}` : base;
  });

  public async main(): Promise<void> {}
}
